import store from 'store'

export const getEnvironment = () => {
    const {
        app: { environment },
    } = store.getState()

    return environment
}
